import { Component, OnInit } from '@angular/core';
import { FeedMetadataService } from '../shared/feed-metadata.service';
import { FeedMetadataItem } from '../shared/models/feed-metadata-item.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'metadata-search-results',
  templateUrl: './metadata-search-results.component.html',
  styleUrls: ['./metadata-search-results.component.css']
})
export class MetadataSearchResultsComponent implements OnInit {

    searchText: string;
    feedMetadataItems: FeedMetadataItem[];
    startCnt: number;
    endCnt: number;


    constructor(private feedMetadataService: FeedMetadataService,
        private router: ActivatedRoute) {

        this.router.queryParams.subscribe((queryParam: any) => {
            const q = queryParam['q'];
            if (q && q !== 'undefined') {
                this.searchText = q;
                this.feedMetadataService.search(this.searchText)
                    .subscribe(results => {
                        this.setResults(results);
                    });
            } else {
                this.feedMetadataService.list()
                    .subscribe(results => {
                        this.setResults(results);
                    });
            }

        });

    }

    ngOnInit() {

    }

    private setResults(results: FeedMetadataItem[]) {
        this.feedMetadataItems = results;
        this.endCnt = results.length;
        this.startCnt = this.endCnt > 0 ? 1 : 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/metadata-search-results/metadata-search-results.component.ts